import { useEffect, useState } from "react";

import { linkFotoVigilancia, subirFotoAutorizacion } from "../../services/vigilancia";

/* Las fotos de un autorizado y el botón para sacar una (Nico, ticket 290:
 * «me gustaría tener la foto del auto o la persona. Que saque vigilancia y la
 * suba»).
 *
 * `capture="environment"` abre directo la cámara de atrás en el teléfono, que
 * es con lo que Vigilancia está en el portón; en una computadora es un
 * selector de archivo común. Las fotos se ven en miniatura y se abren en
 * grande con un toque. */
const FotosAutorizacion = ({ autorizacion, puedeSubir, onSubida }) => {
  const rutas = Array.isArray(autorizacion?.fotos) ? autorizacion.fotos : [];
  const [links, setLinks] = useState({});
  const [subiendo, setSubiendo] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let vivo = true;
    (async () => {
      const nuevos = {};
      for (const r of rutas) nuevos[r] = await linkFotoVigilancia(r);
      if (vivo) setLinks(nuevos);
    })();
    return () => { vivo = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rutas.join("|")]);

  const elegir = async (e) => {
    const archivo = e.target.files?.[0];
    e.target.value = "";
    if (!archivo) return;
    setError("");
    setSubiendo(true);
    try {
      const fotos = await subirFotoAutorizacion(autorizacion, archivo);
      onSubida?.(fotos);
    } catch (err) {
      setError(err?.message || "No se pudo subir la foto.");
    } finally {
      setSubiendo(false);
    }
  };

  const etiqueta = autorizacion?.nombre || autorizacion?.patente || "autorizado";
  return (
    <div className="vig-fotos">
      {rutas.map((r, i) =>
        links[r] ? (
          <a key={r} href={links[r]} target="_blank" rel="noreferrer">
            <img src={links[r]} alt={`Foto ${i + 1} de ${etiqueta}`} className="vig-foto" />
          </a>
        ) : (
          <span key={r} className="sin-dato">foto {i + 1}</span>
        ),
      )}
      {puedeSubir && (
        <label className="btn btn--ghost vig-sm">
          {subiendo ? "Subiendo…" : rutas.length ? "Otra foto" : "Sacar foto"}
          <input
            type="file"
            accept="image/*"
            capture="environment"
            hidden
            disabled={subiendo}
            aria-label={`Foto de ${etiqueta}`}
            onChange={elegir}
          />
        </label>
      )}
      {!puedeSubir && rutas.length === 0 && <span className="sin-dato">—</span>}
      {error && <span className="aduana-error">{error}</span>}
    </div>
  );
};

export default FotosAutorizacion;
